import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducers(organization_id) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/list_producers/${organization_id}/fetch_producers`
    );
  },
  fetchCertifications(organization_id) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/list_producers/${organization_id}/fetch_certifications`
    );
  },
  downloadReport(organization_id) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/list_producers/${organization_id}/download_report`,
      { responseType: "blob" }
    );
  },
};
